<template>
  <div class="owal-tagging-header__container">
    <cotenants
      :cotenants="cotenants"
      :tenant="selectedProfile"
      :badges="badges"
      selection-mode="single"
      @click="handleClick"
    />
  </div>
</template>

<script>
import Cotenants from '@/components/shared/UnitCotenants'
import { mapGetters } from 'vuex'
import { OwalPanelHeader } from '@/libraries/owal-ui'

export default {
  components: {
    Cotenants,
  },
  extends: OwalPanelHeader,
  props: {
    /** @prop {Array} cotenants The cotenants to display in the header. */
    cotenants: {
      type: Array,
      default: () => [],
    },
    /** @prop {Object<String>} badges An object where the keys are identity IDs and the tags are the tag value. */
    badges: {
      type: Object,
      default: () => { return {} },
    },
  },
  computed: {
    ...mapGetters({
      selectedProfile: 'credentialMismatch/selectedProfile',
    }),
    placeholderImageURI () {
      return ''
    },
  },
  methods: {
    /** Emit a click when a cotenant is clicked.
     */
    handleClick (event) {
      const cotenant = event.cotenant
      const buttonIdentifier = `identityId:${cotenant.identityId}`

      /**
       * Emit a "button-click" event, so the panel will treat this as a standard button click.
       * */
      this.$emit('button-click', buttonIdentifier)
    },
  },
}
</script>

<style scoped>
  .owal-tagging-header__container {
    display: flex;
    flex-direction: row;
    background: #c0ccda;
    color: #475669;
    padding: 2.25rem;
  }
</style>
